module.exports = __webpack_public_path__ + "static/img/popup-bg.42c3be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup-bg.png
// module id = MCWs
// module chunks = 1